import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const DetailsPageLink = ({ to, label, extraState = {}, openInNewTab = false, ...props }) => {
  const location = useLocation();

  const previousState = location.state || {};

  const preservedState = {
    filters: previousState.filters || {},
    searchValue: previousState.searchValue || '',
    page: previousState.page || 1,
    showArchived: previousState.showArchived || false,
    ...extraState,
  };
  const newTabProps = openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  return (
    <Link to={to} state={preservedState} {...newTabProps} {...props}>
      <span style={{ whiteSpace: 'nowrap' }}> {label}</span>
    </Link>
  );
};

export default DetailsPageLink;
